'use strict';

var React = require('react');
var reactFinalForm = require('react-final-form');
var Form = require('@piconetworks/form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Form__default = /*#__PURE__*/_interopDefaultLegacy(Form);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var GiftForm = function GiftForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var name = _ref.name,
      fieldContainerProps = _ref.fieldContainerProps,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? null : _ref$description,
      required = _ref.required;
      _ref.defaultValue;
      var rest = _objectWithoutProperties(_ref, ["name", "fieldContainerProps", "description", "required", "defaultValue"]);

  return /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, fieldContainerProps, /*#__PURE__*/React__default['default'].createElement("p", null, description), /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, null, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
    label: "Your Name",
    name: "".concat(name, ".sender_name"),
    component: Form__default['default'].Input,
    type: "text"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest)), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
    label: "Recipient's Name",
    name: "".concat(name, ".recipient_first_name"),
    component: Form__default['default'].Input,
    type: "text"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest)), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
    label: "Recipient's Email",
    name: "".concat(name, ".recipient_email"),
    component: Form__default['default'].Input,
    type: "text"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest)), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, {
    label: "Gift Note",
    name: "".concat(name, ".note"),
    component: Form__default['default'].TextArea,
    type: "text"
  })));
};

module.exports = GiftForm;
